angular.module('unergie.main')
.controller('b2gSelfReportModalCtrl', ($scope, $uibModal, $uibModalInstance, ApiUser, ModalService, BoFeaturesService, AlertManager, MetaWatcher, AdminComments, ErrorCatcher, contract) => {
    $scope.contract = contract

    const reportTemplate = {
        BASE: {
            date: moment().startOf('day').toDate(),
            base: undefined,
        },
        HPHC: {
            date: moment().startOf('day').toDate(),
            hp: undefined,
            hc: undefined,
        },
    }

    $scope.minDate = moment().add(-5, 'day').startOf('day').toDate()
    $scope.maxDate = moment().startOf('day').toDate()

    $scope.mask = '9?9?9?9?9?9?'

    $scope.reportPayload = _.clone(reportTemplate[$scope.contract.id_p_calendar])

    const fieldsToCheck = ['date'].concat($scope.contract.id_p_calendar === 'HPHC' ? ['hp', 'hc'] : ['base'])

    $scope.canSend = () => {
        return _.every(fieldsToCheck, (field) => !!$scope.reportPayload[field]) && !$scope.reporting
    }

    $scope.selfReport = function () {
        if (!$scope.canSend()) {
            return
        }
        const startDate = moment($scope.reportPayload.date).format('YYYY-MM-DD')
        const payload = _.clone($scope.reportPayload)
        delete payload.date
        $scope.message = ''
        $scope.reporting = true
        return ApiUser.selfReportB2G({ id_contract: $scope.contract.id, startDate }, payload).$promise
        .then((reportResult) => {
            if (reportResult && reportResult.status === 'SUCCESS') {
                AlertManager.success('Relève acceptée avec succès, elle apparaîtra dans la liste des relèves après fiabilisation par ENEDIS (1 à 2 jours)', 10000)
                return $scope.ok()
            }
            if (reportResult && reportResult.type) {
                switch (reportResult.type) {
                    case 'LINKY':
                        $scope.message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky communicants.'
                        break
                    case 'ENEDIS':
                        $scope.message = 'Une erreur technique est survenue lors de la transmission à Enedis.'
                        break
                    case 'CONS_INF_0':
                        $scope.message = 'La relève saisie est inférieure à la dernière relève réelle.'
                        break
                    default:
                        $scope.message = 'Une erreur technique est survenue.'
                }
            } else {
                $scope.message = 'Une erreur technique est survenue.'
            }
        })
        .catch((err) => {
            $scope.message = err.data.message
        })
        .finally(() => {
            $scope.reporting = false
        })
    }

    $scope.ok = () => $uibModalInstance.close()
    $scope.close = () => $uibModalInstance.dismiss()
})
